import { render, staticRenderFns } from "./RoleIndexView.vue?vue&type=template&id=38f0a64a&scoped=true&"
import script from "./RoleIndexView.vue?vue&type=script&lang=js&"
export * from "./RoleIndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f0a64a",
  null
  
)

export default component.exports